import { LuArrowRight } from 'react-icons/lu';
import lawyerImage from 'src/assets/lawyer_suit.jpg';
import legalConsultingImage from 'src/assets/legal_consulting.jpg';
import SectionLayout from 'src/layouts/SectionLayout';
import CustomButton from '../CommonComps/Buttons/CustomButton';

const CareersSection = () => {
  // rendering careers section component here
  return (
    <SectionLayout
      id='careers'
      titleFirstPart='Become an'
      titleSecondPart='Associate'
      additionalClassNames='bg-legal-bg-brown'
      isFullWidth
    >
      <div className='w-[95%] max-w-[1800px] lg:w-[90%] xl:w-4/5 mx-auto flex flex-col-reverse md:flex-row items-center justify-between mt-10 gap-10'>
        <div className='md:w-1/2 space-y-5 text-center md:text-left'>
          <h2 className='text-3xl md:text-4xl lg:text-5xl font-medium text-legal-dark-gray'>
            Join Our Legal Network & <br />{' '}
            <span className='font-bold text-legal-brown italic'>
              Elevate Your Career
            </span>
          </h2>

          <p className='font-marcellus text-base md:text-xl text-legal-black'>
            Become an associate, provide legal services online,{' '}
            <br className='hidden xl:block' /> and enjoy the flexibility to work
            from anywhere, anytime.
          </p>

          <CustomButton
            title='Start Your Journey'
            variant='primary'
            icon={
              <LuArrowRight className='size-5 duration-500 group-hover:rotate-90' />
            }
          />
        </div>

        <div className='relative flex items-center justify-center flex-1'>
          <div className='relative w-full md:w-[300px] lg:w-[450px] h-[400px] lg:h-[550px] rounded-tl-3xl rounded-br-3xl overflow-hidden'>
            <img
              className='size-full object-cover'
              src={lawyerImage}
              alt='professional lawyer in suits'
            />

            <div className='absolute inset-0 size-full bg-legal-dark-blue/60' />
          </div>

          <div className='absolute top-1/2 -translate-y-1/2 -right-1 md:-right-3 lg:-right-8 2xl:right-8 w-3/5 md:w-[200px] lg:w-[275px] h-[250px] lg:h-[375px] border-2 border-legal-brown rounded-tl-3xl rounded-br-3xl overflow-hidden'>
            <img
              className='size-full object-cover'
              src={legalConsultingImage}
              alt='professional lawyer in suits'
            />
          </div>
        </div>
      </div>
    </SectionLayout>
  );
};

export default CareersSection;
